;(function ($) {
  "use strict"
  $(function () {
    $(document).click(function (e) {
      var $currItem = $(e.target).closest(".reveal__item")
      if ($currItem.length !== 0) {
        var text = $currItem.text()
        $currItem.closest(".reveal").find(".reveal__acc").text(text)
      }
    })
  })
})(jQuery)
